import ParallaxImageBase from './ParallaxImageBase.js';

/**
 * @typedef {object} ParallaxImageDesktopRef
 * @property {HTMLElement} target
 */

/**
 * @typedef {object} ParallaxImageDesktopInterface
 * @property {ParallaxImageDesktopRef} $refs
 */

/**
 * ParallaxImageDesktop class.
 */
export default class ParallaxImageDesktop extends ParallaxImageBase {
  /**
   * Config.
   */
  static config = {
    refs: ['target'],
    options: {
      ratio: {
        type: Number,
        default: 0.1,
      },
    },
  };

  /**
   * Ratio getter
   * @returns {number}
   */
  get ratio() {
    return this.$options.ratio;
  }
}
